import { render, staticRenderFns } from "./AudioTrack.vue?vue&type=template&id=3acb5942&scoped=true&"
import script from "./AudioTrack.vue?vue&type=script&lang=js&"
export * from "./AudioTrack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acb5942",
  null
  
)

export default component.exports